import React, { FC } from 'react'

const DroppeUserIcon: FC = () => (
  <svg
    width="54"
    height="54"
    viewBox="0 0 54 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="27.0009"
      cy="27.0009"
      r="19.7196"
      fill="white"
    />
    <path
      d="M43.9942 37.0098C38.4659 46.3932 26.3776 49.5185 16.9942 43.9902C7.61072 38.462 4.48545 26.3737 10.0137 16.9902C15.5419 7.60679 27.6302 4.48152 37.0137 10.0098C46.3971 15.538 49.5224 27.6263 43.9942 37.0098ZM12.5841 18.5046C7.89227 26.4685 10.5447 36.7279 18.5085 41.4198C26.4724 46.1117 36.7318 43.4592 41.4237 35.4954C46.1156 27.5315 43.4631 17.2721 35.4993 12.5802C27.5355 7.88834 17.276 10.5408 12.5841 18.5046Z"
      fill="#D6D6DC"
    />
    <circle
      cx="42"
      cy="39"
      r="8"
      fill="white"
    />
    <path
      d="M50 39C50 43.4183 46.4183 47 42 47C37.5817 47 34 43.4183 34 39C34 34.5817 37.5817 31 42 31C46.4183 31 50 34.5817 50 39ZM36.2128 39C36.2128 42.1962 38.8038 44.7872 42 44.7872C45.1962 44.7872 47.7872 42.1962 47.7872 39C47.7872 35.8038 45.1962 33.2128 42 33.2128C38.8038 33.2128 36.2128 35.8038 36.2128 39Z"
      fill="#D6D6DC"
    />
    <path
      d="M42.1523 42H40.9141L40.9219 41.0859H42.1523C42.4596 41.0859 42.7188 41.0169 42.9297 40.8789C43.1406 40.7383 43.2995 40.5339 43.4062 40.2656C43.5156 39.9974 43.5703 39.6732 43.5703 39.293V39.0156C43.5703 38.724 43.5391 38.4674 43.4766 38.2461C43.4167 38.0247 43.3268 37.8385 43.207 37.6875C43.0872 37.5365 42.9401 37.4232 42.7656 37.3477C42.5911 37.2695 42.3906 37.2305 42.1641 37.2305H40.8906V36.3125H42.1641C42.5443 36.3125 42.8919 36.3776 43.207 36.5078C43.5247 36.6354 43.7995 36.819 44.0312 37.0586C44.263 37.2982 44.4414 37.5846 44.5664 37.918C44.694 38.2487 44.7578 38.6172 44.7578 39.0234V39.293C44.7578 39.6966 44.694 40.0651 44.5664 40.3984C44.4414 40.7318 44.263 41.0182 44.0312 41.2578C43.8021 41.4948 43.5273 41.6784 43.207 41.8086C42.8893 41.9362 42.5378 42 42.1523 42ZM41.5781 36.3125V42H40.4062V36.3125H41.5781Z"
      fill="#62BFAD"
    />
  </svg>
)

export default DroppeUserIcon
